//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get'
import slugify from '@sindresorhus/slugify'
import hasArticles from '~/mixins/hasArticles'
import ArticleDetail from '~/components/article/article-detail/ArticleDetail.vue'

export default {
  components: { ArticleDetail },
  mixins: [hasArticles],

  // eslint-disable-next-line handle-callback-err
  async fetch({ error, params, redirect, store }) {
    try {
      await store.dispatch('articles/fetchById', Number(params.id))
      const article = store.getters['articles/find'](Number(params.id))

      if (slugify(article.contentSlug) !== slugify(params.slug)) {
        redirect(article.routePath)
      }
    } catch (e) {
      if (get(e, 'response.status') === 404) {
        error({ statusCode: 404, message: 'Artikel tidak ditemukan.' })
      } else {
        throw e
      }
    }
  },

  computed: {
    article() {
      return this.findArticle(Number(this.$route.params.id))
    },
  },

  head() {
    return {
      title: this.article.title + ' | Charmgirlstalk',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.article.description,
        },
      ],
    }
  },
}
